import { CONSTANTS } from '../validationReportToken/constants';
import * as actionTypes from './actionTypes';
import { paymentTypeService, refreshTokenService } from './services';
import { userLogout } from '@app/src/views/Login/login/state/login/actions';

const fetchPaymentTypeRequest = () => ({
  type: actionTypes.FETCH_PAYMENT_TYPE_REQUEST
});

const fetchPaymentTypeFailure = (errorMessage: string, errorRol?: boolean) => ({
  type: actionTypes.FETCH_PAYMENT_TYPE_FAILURE,
  errorMessage,
  errorRol
});

const fetchPaymentTypeSuccess = (data) => ({
  type: actionTypes.FETCH_PAYMENT_TYPE_SUCCESS,
  data
});

export const fetchPaymentType = (url: string): Function => {
  return async dispatch => {
    dispatch(fetchPaymentTypeRequest());
    try {
      const data = await paymentTypeService.getData(url);
      dispatch(fetchPaymentTypeSuccess(data));
    } catch (error) {
      if (!error) {
        dispatch(fetchPaymentTypeFailure('Ocurrió un error en el servidor'));
        return;
      }
      if (error.code === CONSTANTS.expiredAccessToken) {
        await dispatch(fetchRefreshToken(url));
        return;
      }
      dispatch(fetchPaymentTypeFailure(error.message));
    }
  }
};

const fetchRefreshToken = (url) => {
  return async dispatch => {
    try {
      const refreshToken = localStorage.getItem('refreshtoken');
      const { data } = await refreshTokenService.getData(refreshToken);
      const value = await paymentTypeService.getData(url, data.accessToken);
      await dispatch(fetchPaymentTypeSuccess(value));
    } catch (error) {
      await dispatch(userLogout())
    }
  }
}
